import type { ComponentStyleConfig } from '@chakra-ui/react';

const Text: ComponentStyleConfig = {
  baseStyle: {
    color: 'admin.black.400',
  },
};

export default Text;
